document.addEventListener('DOMContentLoaded', function () {
    var IwishVideoSwiper = new Swiper(".IwishVideoSwiper", {
        slidesPerView : 1,
        spaceBetween: 0,
        // loop: true,
        breakpoints: {
            768: {
                slidesPerView : 3,
                spaceBetween: 15,
            },
            1080: {
                slidesPerView : 4,
                spaceBetween: 20,
            },
        },
        navigation: {
            nextEl: ".iwish-reviews-video-box .swiper-button-next",
            prevEl: ".iwish-reviews-video-box .swiper-button-prev",
        },
    });
});